import React from "react";
import { defineBlock } from "@smartfire/gutenberg-react";
import { ReactComponent as Arrow } from "../assets/arrow_right.svg";
import { ReactComponent as FooterLogo } from "./assets/footer_logo_SPI.svg";
import { ReactComponent as Phone } from "./assets/smartphone.svg";
import { ReactComponent as Facebook } from "../assets/facebook.svg";
import { ReactComponent as LinkedIn } from "../assets/linkedin.svg";
import { ReactComponent as Youtube } from "../assets/youtube.svg";
import FoodSafety from "./assets/food_safety.png";
import Ifs from "./assets/ifs.png";
import Aeo from "./assets/aeo.png";
import Smeta from "./assets/smeta.png";
import Aura from "./assets/aura.png";
import Iso14001 from "./assets/iso-14001.jpg";
import Isoeic27001 from "./assets/isoeic-27001.jpg";
import style from "./block.module.scss";
import { useTranslation } from "react-i18next";

function Block({
  custom_settings,
  menuSpi,
  menuMetiers,
  menuBottom,
  nosMetiers,
  certifications,
}) {
  const { t, i18n } = useTranslation();

  return (
    <div className={style.footer}>
      <div className={style.footerContainer}>
        <div className={style.content}>
          <div className={style.logo}>
            <FooterLogo />
          </div>
          <div className={style.row}>
            <div className={style.colContact}>
              <h3>Contact</h3>
              {custom_settings["address"] && (
                <p className={style.address}>{custom_settings["address"]}</p>
              )}
              {custom_settings["city"] && (
                <p className={style.city}>{custom_settings["city"]}</p>
              )}
              {custom_settings["phone"] && (
                <p className={style.phone}>
                  <Phone className={style.icon} />
                  <a href={"tel:" + custom_settings["phone"]}>
                    {custom_settings["phone"]}
                  </a>
                </p>
              )}

              <div className={style.socialBar}>
                {custom_settings["facebook"] && (
                  <a
                    href={custom_settings["facebook"]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.facebook}
                  >
                    <Facebook />
                  </a>
                )}
                {custom_settings["youtube"] && (
                  <a
                    href={custom_settings["youtube"]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.youtube}
                  >
                    <Youtube />
                  </a>
                )}
                {custom_settings["linkedin"] && (
                  <a
                    href={custom_settings["linkedin"]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.linkedin}
                  >
                    <LinkedIn />
                  </a>
                )}
              </div>

              {custom_settings["contact_url"] && (
                <a
                  className={style.link}
                  href={
                    custom_settings["contact_url"] +
                    (i18n.language === "en" ? "?lang=en" : "")
                  }
                >
                  {t("Nous contacter")}
                  <Arrow />
                </a>
              )}
            </div>
            <div className={style.colSpi}>
              <h3>SPI</h3>
              <div
                className={style.menuCol}
                dangerouslySetInnerHTML={{ __html: menuSpi }}
              />
            </div>
            <div className={style.colMetiers}>
              <h3>{nosMetiers}</h3>
              <div
                className={style.menuCol}
                dangerouslySetInnerHTML={{ __html: menuMetiers }}
              />
            </div>
            <div className={style.colCertif}>
              <h3>{certifications}</h3>
              <ul className={style.certifications}>
                <li>
                  <img src={FoodSafety} alt="Food Safety System" />
                </li>
                <li>
                  <img src={Ifs} alt="IFS" />
                </li>
                <li>
                  <img src={Aeo} alt="AEO" />
                </li>
                <li>
                  <img src={Smeta} alt="SMETA" />
                </li>
                <li>
                  <img src={Aura} alt="Région Auvergne-Rhône-Alpes" />
                </li>
                <li>
                  <img src={Iso14001} alt="Norme ISO 14001" />
                </li>
                <li>
                  <img src={Isoeic27001} alt="Norme ISO/CEI 27001" />
                </li>
              </ul>
            </div>
          </div>
          <div className={style.footerBottom}>
            <div
              className={style.menuBottom}
              dangerouslySetInnerHTML={{ __html: menuBottom }}
            />
            <p>{new Date().getFullYear()} © Tous droits réservés</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Footer",
  },
});
